"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
// Flattens all child elements into a single list
var flatten = function (children, flat) {
    if (flat === void 0) { flat = []; }
    // eslint-disable-next-line no-param-reassign
    flat = __spread(flat, react_1.default.Children.toArray(children));
    if (children &&
        typeof children !== 'string' &&
        typeof children !== 'number' &&
        typeof children !== 'boolean' &&
        !Array.isArray(children)) {
        if (children.props && children.props.children) {
            return flatten(children.props.children, flat);
        }
    }
    return flat;
};
// Strips all circular references and internal fields
var simplify = function (children) {
    var flat = flatten(children);
    return flat.map(function (_a) {
        var key = _a.key, ref = _a.ref, type = _a.type, _b = _a.props, children = _b.children, props = __rest(_b, ["children"]);
        return ({
            key: key,
            ref: ref,
            type: type,
            props: props,
        });
    });
};
function compareChildren(prevChildren, nextChildren) {
    if (prevChildren && nextChildren) {
        if (react_1.default.Children.toArray(prevChildren).length !==
            react_1.default.Children.toArray(nextChildren).length) {
            return false;
        }
        return (JSON.stringify(simplify(prevChildren)) ===
            JSON.stringify(simplify(nextChildren)));
    }
    return !prevChildren && !nextChildren;
}
exports.default = compareChildren;
//# sourceMappingURL=compareChildren.js.map